import { useDeleteUnit } from "http-hooks/unit/useUnit";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteUnit({ id, onClose, setOpen }) {
  const { mutateAsync, isPending } = useDeleteUnit();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Unit"
      description="Are you sure you want to delete this Unit? This Unit will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
